import ReactTooltip from "@huner2/react-tooltip";
import styled from "styled-components";
import React from "react";
import { TooltipProps } from "./Tooltip.d";

const Wrapper = styled(ReactTooltip)<WraperProps>`
  &.__react_component_tooltip {
    padding: 0;
    background:#203B60;
  }
  &.__react_component_tooltip.show {
    // position : absolute;
    opacity: 1;
    width: ${(props) => props.width || 216}px;
    padding: ${(props) => props.padding}px;
    border-radius: ${(props) => props.borderRadius}px;
    max-width: ${(props) => window.screen.availWidth}px;
    z-index: ${(props) => props.zIndex || 12};
    white-space: initial;
    font-weight: 600;
    // color : #959D9B;
  }
  &.__react_component_tooltip.show::after {
    content: none;
  }
  &.__react_component_tooltip.show.place-right {
    margin: 0px;
  }
  &.__react_component_tooltip .multi-line {
    text-align: left;
  }
  &.__react_component_tooltip.show.place-bottom {
    margin: 0;
  }
`;
interface WraperProps {
  width?: string | number;
  padding?: number | string;
  borderRadius?: number;
  zIndex?: number;
}

interface ExtTooltipProps extends TooltipProps {
  width?: string | number;
  padding?: number | string;
  backgroundColor?: string;
  borderRadius?: number;
  children?: React.ReactNode;
  show?: boolean;
}

const Tooltip = React.forwardRef<ReactTooltip, ExtTooltipProps>(
  (props, ref) => {
    const {
      effect = "solid",
      place = "bottom",
      className = "tooltip",
      type = "info",
      globalEventOff = "click",
      padding = '0',
      backgroundColor = "#0A172B",
      width,
      show = true,
      ...rest
    } = props;
    return show ? (
      <Wrapper
        ref={ref}
        effect={effect}
        place={place}
        className={className}
        type={type}
        globalEventOff={globalEventOff}
        backgroundColor={backgroundColor}
        padding={padding}
        clickable
        width={width}
        {...rest}
      >
        {props.children}
      </Wrapper>
    ) : null;
  }
);

export default Tooltip;

